module.exports = __webpack_public_path__ + "img/pic2.7d098ffb.png";